// extracted by mini-css-extract-plugin
export var section = "_23-1";
export var topNav = "_23-0";